enum InvalidProductReasonEnum {
	// Sell-stopped
	retailItemNotAvailable = 'RETAIL_ITEM_NOT_AVAILABLE'
}

export default InvalidProductReasonEnum;
